import { Form } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import { FormContent } from "@/components/page-canvas";

import { Button } from "@/components/ui/button";
import {
  Field,
  FieldDescription,
  FieldError,
  FieldLabel,
} from "@/components/ui/field";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Spinner } from "@/components/ui/spinner";
import { userStripeConnectAccountPath } from "@/routes";

export function StripeConnectForm({
  connected,
  stripeConfigured,
}: {
  connected: boolean;
  stripeConfigured: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Form action={userStripeConnectAccountPath()} method="post">
      {({ processing, errors }) => (
        <FormContent className="space-y-3">
          {!connected && (
            <Field data-invalid={!!errors.country}>
              <FieldLabel htmlFor="connect_country">
                {t("connect_ui.country")}
              </FieldLabel>
              <Select
                name="country"
                defaultValue={null}
                required
                disabled={!stripeConfigured || processing}
                items={{
                  RO: t("connect_ui.romania"),
                  US: t("connect_ui.united_states"),
                }}
              >
                <SelectTrigger
                  id="connect_country"
                  className="w-full"
                  aria-invalid={!!errors.country}
                  aria-describedby={
                    errors.country
                      ? "connect_country_description connect_country_error"
                      : "connect_country_description"
                  }
                >
                  <SelectValue placeholder={t("connect_ui.select_country")} />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="RO">{t("connect_ui.romania")}</SelectItem>
                  <SelectItem value="US">
                    {t("connect_ui.united_states")}
                  </SelectItem>
                </SelectContent>
              </Select>
              <FieldDescription id="connect_country_description">
                {t("connect_ui.country_help")}
              </FieldDescription>
              <FieldError id="connect_country_error">
                {errors.country}
              </FieldError>
            </Field>
          )}
          <Button type="submit" disabled={processing || !stripeConfigured}>
            {processing && <Spinner />}
            {connected ? t("connect_ui.continue") : t("connect_ui.start")}
          </Button>
        </FormContent>
      )}
    </Form>
  );
}
